import { render } from "./ChattingMessage.vue?vue&type=template&id=72535ff1&scoped=true"
import script from "./ChattingMessage.vue?vue&type=script&lang=js"
export * from "./ChattingMessage.vue?vue&type=script&lang=js"

import "./ChattingMessage.vue?vue&type=style&index=0&id=72535ff1&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NfzNB5gn/0/softbot/chatbot/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72535ff1"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QIcon});
